import * as types from "app/core/components/dashboard/d3/types"
import * as d3 from "d3"
import { ButtonDatum } from "app/core/components/dashboard/d3/types"

export const mouseTarget = (
  event: MouseEvent,
): {
  textTarget?: types.ButtonSelection
  resizerTarget?: types.ButtonSelection
  buttonTarget?: types.ButtonSelection
} => {
  const clickTarget = event?.target as Element | null

  // walk up from the actual event target so a click anywhere within a button
  // resolves correctly — including the text content inside the foreignObject,
  // which sits in the centre of the button
  const resizerElement = clickTarget?.closest?.(".resizer")
  if (resizerElement) {
    return {
      resizerTarget: d3.select<SVGGElement, ButtonDatum>(resizerElement as any),
      buttonTarget: d3.select<SVGGElement, ButtonDatum>(
        resizerElement.closest(".playerdash-dashboard-button") as any,
      ),
    }
  }

  const buttonElement = clickTarget?.closest?.(".playerdash-dashboard-button")
  if (buttonElement) {
    return {
      buttonTarget: d3.select<SVGGElement, ButtonDatum>(buttonElement as any),
    }
  }

  return {}
}

export const minimum = <T>(data: T[], extractor: (item: T) => number) => {
  return data.reduce((minimum: number, item: T) => {
    if (extractor(item) < minimum) {
      return extractor(item)
    }
    return minimum
  }, Number.MAX_SAFE_INTEGER)
}

export const maximum = <T>(data: T[], extractor: (item: T) => number) => {
  return data.reduce((minimum: number, item: T) => {
    if (extractor(item) > minimum) {
      return extractor(item)
    }
    return minimum
  }, 0)
}
